import { Virtualizer } from "@tanstack/react-virtual"
import React from "react"
import { PhotoRecord } from "@/lib/catalog"
import { ProjectItem } from "@/store/project/projects-service"

import { MemoizedThumbnail } from "@/components/ui/Thumbnail"

export const FilmstripPhotos: React.FC<{
	photosVirtualizer: Virtualizer<HTMLDivElement, Element>
	displayedPhotos: PhotoRecord[]
	project: ProjectItem
}> = ({ photosVirtualizer, displayedPhotos, project }) => {
	const photosCols = photosVirtualizer.getVirtualItems()

	return (
		<div
			className={`relative m-1 mb-0 h-[112px]`}
			style={{ width: photosVirtualizer.getTotalSize() }}
		>
			{photosCols.map((virtualColumn) => {
				const photo = displayedPhotos[virtualColumn.index]

				if (!photo) {
					return null
				}

				return (
					<div
						key={photo.id}
						className={`absolute left-0 top-0 h-full w-[112px]`}
						style={{
							transform: `translateX(${virtualColumn.start}px)`,
						}}
					>
						<MemoizedThumbnail
							size={"small"}
							photo={photo}
							project={project}
							isStackedPhoto={false}
						/>
					</div>
				)
			})}
		</div>
	)
}
